import { site } from "./site";

type LeadDetails = {
  name: string;
  email?: string;
  phone?: string;
  company?: string;
  segment?: string;
  revenue_range?: string;
  employees_range?: string;
  current_accountant?: string;
  message?: string;
};

const fields: { key: keyof LeadDetails; label: string }[] = [
  { key: "name", label: "Nome" },
  { key: "email", label: "E-mail" },
  { key: "phone", label: "Telefone/WhatsApp" },
  { key: "company", label: "Empresa" },
  { key: "segment", label: "Segmento" },
  { key: "revenue_range", label: "Faturamento" },
  { key: "employees_range", label: "Número de funcionários" },
  { key: "current_accountant", label: "Situação contábil" },
  { key: "message", label: "Mensagem" },
];

export function leadWhatsappUrl(details: LeadDetails) {
  const lines = fields.flatMap(({ key, label }) => {
    const value = details[key]?.trim();
    return value ? [`${label}: ${value}`] : [];
  });
  return `https://wa.me/${site.whatsappNumber}?text=${encodeURIComponent(`Olá! Preenchi o formulário no site da Patrimonial.\n\n${lines.join("\n")}`)}`;
}